<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5CkIUl/tc-custom/9781464205606.jpg?1718183000417" alt="This image is the cover for the book Burgundy, Vengeance in the Vineyard Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Burgundy, Vengeance in the Vineyard Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p><b>"<i>Burgundy: Twisted Roots</i> is an intriguing and multi-layered novel about love, wine and intrigue, steeped in a deep knowledge of the seductive French lifestyle, from wild boar hunts to wine harves feasts, with side servings of skullduggery and inheritance laws." —MARTIN WALKER, bestselling author of the Bruno, Chief of Police series</b></p><p>Max Maguire of the NYPD, daughter of a legendary NY cop and a French mother disowned by her aristocratic family when she married, met examining magistrate Olivier Chaumont over murder at the wedding of an old friend in the Champagne wine region. They remained on-again-off-again partners and lovers over more murder again, this time in Bordeaux. And now, six months later, Max is on her way to Burgundy where it's time to give up her promising career and commit—or split.</p><p>Murder occurs. There's a mystery girl, American. Fractured families. Motives aplenty. But the story's real fascination lies in two things French: the wine culture and French inheritance laws which are convoluted and guaranteed to spark family wars, even unto death. And the French justice system functions differently which frustrates Max, an action-oriented, straightforward investigator, and causes some friction with Olivier. Janet Hubbard wraps up her Vengeance in the Vineyard trilogy with a surprise and solutions that will please readers.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Janet Hubbard
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3ba8c92f